import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import { Share } from '@ifeng/ui_pc_share';
import LazyLoad from '@ifeng/ui_pc_lazyLoad';
import { addEventListener } from '@ifeng/ui_base';
import Loadable from 'react-loadable';
import styles from './index.css';
// import { Comment } from 'ThreeTerminal_pc';

const LoadComment = Loadable({
    loader: () => import('./comment'),
    loading() {
        return <div />;
    },
});

class CommentArea extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const commentConfig = {
            // 文章单页的页面地址
            docUrl: content.commentUrl,
            // 文章的标题
            docTitle: content.title,
            // 文章评论的skey，这个是在后端生成好后给到前端的
            skey: content.skey,
            // 兼容以后的专题评论
            speUrl: '',
            // 文章pc的页面地址
            pcUrl: location.href,
            // 获取评论内容接口
            cmtNumUrl: '//comment.ifeng.com/get.php',
            // 评论内容字数长度
            cmtLength: 1000,
            // 提交评论内容接口
            cmtPostUrl: '//comment.ifeng.com/post.php',
            // 最热评论数量
            hotLimit: 2,
            // 推荐评论接口
            cmtVoteUrl: '//comment.ifeng.com/vote.php',
            // 现实回复的楼层
            replyLimit: 3,
            // 举报提交接口
            jubUrl: '//comment.ifeng.com/report',
            // 举报次数，便于每次回调函数名不同
            jubNum: 0,
            // 是否是评论详情页面
            isComment: false,
            order: 'both', // 'uptimes' 按热度排序，'create_time' 按时间排序， 'both', 两者同时存在
            options: 1, // 0 先显示最新，后显示最热，1 反之，此配置在 order 是 both 的情况下才生效
            recentLimit: 2, // 最近评论数量
            recentReplyLimit: 3, // 最近评论数量显示回复的楼层
        };

        return (
            <div className={styles.content} style={{ marginTop: '50px' }}>
                <div>
                    <LazyLoad>
                        <LoadComment content={{ commentConfig }} />
                    </LazyLoad>
                </div>
            </div>
        );
    }
}

export default errorBoundary(CommentArea);
